import React, { Component } from "react";
import { NavLink } from "react-router-dom";

export class AssinaturaLista extends Component {
  constructor (props) {
    super(props);

    this.state = {
    };
  }

  render () {
    const { props, state } = this;

    return (
      <div>
        <h4>Here's a List</h4>
        <ul>
          <li>
            <NavLink to={"/assinaturas/236399"}>
              Fabio Y. Goto (236399)
            </NavLink>
          </li>
          <li>
            <NavLink to={"/assinaturas/90403"}>
              Guilherme Rey (90403)
            </NavLink>
          </li>
          <li>
            <NavLink to={"/assinaturas/132728"}>
              Rodrigo Portela (132728)
            </NavLink>
          </li>
          <li>
            <NavLink to={"/assinaturas/bkcugseaj"}>
              SubscriberId Inválido
            </NavLink>
          </li>
        </ul>
      </div>
    );
  }
}
